import NavigationSidebar from "../NavigationSidebar/index.js";
import ExploreComponent from "../ExploreScreen/ExploreComponent.js";
import PostList from "../PostList/index.js";
import React from "react";

const HomeScreen = () => {
  return(
        <div className="container bg-black text-white">
          <div className="row mt-2 gx-0">
            <div className="col-sm-2 col-md-2 col-lg-1 col-xl-2 col-xxl-2">
              <NavigationSidebar active={"home"}/>
            </div >
            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
              <PostList/>
            </div>
            <div className="col-sm-0 col-md-0 col-lg-4 col-xl-4 col-xxl-4 d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block">
              <ExploreComponent/>
            </div>
          </div>
        </div>
    );
};
export default HomeScreen;